import React from "react";

const PARTNERS = [
    {
        slug: "agmon",
        ext: "svg",
        name: "Agmon with Tulchinsky",
        desc: "220+ lawyers · Leading counsel for key players in the Israeli economy",
        darken: false,
    },
    {
        slug: "lipa",
        ext: "svg",
        name: "Lipa Meir & Co.",
        desc: "Est. 1987 · Comprehensive legal services across practice areas",
        darken: false,
    },
    {
        slug: "ebn",
        ext: "png",
        name: "EBN",
        desc: "Top-ranked · Israel's fastest-growing full-service law firm",
        darken: false,
    },
    {
        slug: "har",
        ext: "png",
        name: "Hadad, Roth, Shenhar",
        desc: "Commercial law and litigation counsel of distinction",
        darken: true,
    },
    {
        slug: "ysl",
        ext: "png",
        name: "Salomon Lifshitz & Co.",
        desc: "Est. 1923 · A century of legal excellence in Israel",
        darken: false,
    },
    {
        slug: "zes",
        ext: "svg",
        name: "Zemah Schneider & Co.",
        desc: "Full-service law firm with a modern approach to legal excellence",
        darken: false,
    },
];

const Partners: React.FC = () => (
    <section className="partners" id="partners">
        <div className="section-number on-light">05</div>
        <div className="container">
            <span className="section-eyebrow">Trusted By</span>
            <h2 className="section-title dark">
                Leading Law Firms<br />Across Israel
            </h2>
            <p className="section-intro">
                Serving Israel's legal community with reliable IT solutions tailored
                to their exacting standards of confidentiality and uptime.
            </p>

            <div className="partners-grid">
                {PARTNERS.map((p, i) => (
                    <div className="partner-card" key={i}>
                        <div className="partner-index">{String(i + 1).padStart(2, "0")}</div>
                        <div className="partner-logo-wrap">
                            <img
                                src={`/logos/${p.slug}.${p.ext}`}
                                alt={`${p.name} logo`}
                                className={`partner-logo-img${p.darken ? " partner-logo-darken" : ""}`}
                            />
                        </div>
                        <h3>{p.name}</h3>
                        <p>{p.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Partners;
